import styled from 'styled-components';
import { BasketScrappageDetailsStyled } from '../BasketScrappageDetailsStyled';
import { rem } from 'polished';

export const BasketScrappageDetailsDS = styled(BasketScrappageDetailsStyled)`
    .titleWrapper {
        .title {
            font-size: ${rem('24px')} !important;
        }
    }

    .description {
        .link {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }
    }
`;
